import { Box, BoxProps, Heading, lgBumps } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import { isNil } from 'lodash-es'
import React, { FunctionComponent } from 'react'

import { InputConfig } from '../../../../state/configuration'
import { FormFormatter } from '../../FormFormatter'

export interface InputRepeaterHeaderProps extends BoxProps {
  t: TFunction
  value: unknown | undefined
  element: InputConfig
}

export const InputRepeaterHeader: FunctionComponent<InputRepeaterHeaderProps> = ({
  t,
  value,
  element,
  ...props
}) =>
  isNil(value) ? null : (
    <Box borderTopWidth={1} {...props}>
      <Heading variant='h3' as='h3' typoSize='lg' mt={lgBumps}>
        <FormFormatter t={t} input={element} value={value} />
      </Heading>
    </Box>
  )
